import { IHelpVisor } from "@interfaces/screens/help-visor.interface";
import { BasePresenter } from "@presenters/base/base.presenter";


export class HelpVisorPresenter extends BasePresenter<IHelpVisor> {


  constructor() {
    super();
  }

  public async initialize(){       
      this.dispatcherUnsetSetLoading();        
  }
}

export default HelpVisorPresenter;
